import React, { useRef } from "react";
import { useOutsideClickHandler } from "../../../../Hooks/useOutsideClick";
import Close from "../../../../Assets/Modals/closeIcon.svg";

const RejectedReasonModal = ({ rejectReason, closeRejectedModal }) => {
  const wrapperRef = useRef(null);

  useOutsideClickHandler(wrapperRef, () => {
    closeRejectedModal();
  });

  const handleCloseButtonClick = () => {
    closeRejectedModal();
  };
  return (
    <div className="bg-[#00000080] transition-all duration-100 ease-in-out fixed z-50 size-full top-0 left-0 flex justify-center items-center">
      <div
        ref={wrapperRef}
        className="font-urbanist-regular w-[45%] h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-6 shadow-[0px_0px_12px_0px_#0000003D]"
      >
        <div className="flex items-center justify-between">
          <h1 className="font-semibold text-2xl text-[#121212]">
            Reason for Rejection
          </h1>

          <button onClick={handleCloseButtonClick}>
            <img src={Close} alt="Close Modal" />
          </button>
        </div>

        <p className="font-medium text-base text-[#121212]">{rejectReason}</p>
      </div>
    </div>
  );
};

export default RejectedReasonModal;
